import React from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { useSwipeable } from 'react-swipeable';
import './ImageViewer.css';

const ImageViewer = ({
  images = [],
  currentIndex = 0,
  isVisible = false,
  onClose,
  onNext,
  onPrevious
}) => {
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (onNext && images.length > 1) {
        onNext();
      }
    },
    onSwipedRight: () => {
      if (onPrevious && images.length > 1) {
        onPrevious();
      }
    },
    preventDefaultTouchmoveEvent: false,
    trackMouse: true,
    delta: 10
  });

  if (!isVisible || !images.length) return null;

  return (
    <div className="image-viewer-overlay" onClick={onClose}>
      <div
        className="image-viewer-content"
        onClick={(e) => e.stopPropagation()}
        {...handlers}
      >
        <img
          src={images[currentIndex]}
          alt="Product"
          className="viewer-image"
          {...handlers}
        />

        {/* Image Counter */}
        {images.length > 1 && (
          <div className="image-counter">
            {currentIndex + 1} / {images.length}
          </div>
        )}

        {/* Modal Navigation Arrows */}
        {images.length > 1 && (
          <>
            <button
              className="modal-nav-arrow modal-nav-arrow-left"
              onClick={onPrevious}
              aria-label="Previous image"
            >
              <FaChevronLeft />
            </button>
            <button
              className="modal-nav-arrow modal-nav-arrow-right"
              onClick={onNext}
              aria-label="Next image"
            >
              <FaChevronRight />
            </button>
          </>
        )}

        {/* Close Button */}
        <button
          className="modal-close-button"
          onClick={onClose}
          aria-label="Close image viewer"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default ImageViewer; 